// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/accounting.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcceptMatchRequest, Account, AccountAnalysisResponse, AccountBalance, AccountStatementResponse, AgentDecision, ApproveDecisionRequest, ApproveEntryRequest, AutonomyConfig, BatchPostEntriesRequest, BatchPostEntriesResponse, BatchReverseEntriesRequest, BatchReverseEntriesResponse, BudgetVarianceResponse, CashFlowStatement, CheckCreditRequest, CheckCreditResponse, CloseChecklist, ClosePeriodRequest, CreateAccountRequest, CreateFixedAssetRequest, CreateReconSessionRequest, CreateRecurringEntryRequest, CrossTabBalanceResponse, DeleteRecurringEntryRequest, DisposeFixedAssetRequest, DraftEntryRequest, FinalizeReconRequest, FinancialStatement, FiscalPeriod, FixedAsset, GetAccountAnalysisRequest, GetAccountRequest, GetAccountStatementRequest, GetAutonomyConfigRequest, GetBalanceRequest, GetBudgetVarianceRequest, GetCloseChecklistRequest, GetCounterpartyReconRequest, GetCounterpartyReconResponse, GetCrossTabBalanceRequest, GetEntryRequest, GetReconSessionRequest, GetReportRequest, GetSchemaRequest, GetTrialBalanceRequest, JournalEntry, LedgerSchemaProto, ListAccountsRequest, ListAccountsResponse, ListDecisionsRequest, ListDecisionsResponse, ListEntriesRequest, ListEntriesResponse, ListFixedAssetsRequest, ListFixedAssetsResponse, ListIcTransactionsRequest, ListIcTransactionsResponse, ListPeriodsRequest, ListPeriodsResponse, ListRecurringEntriesRequest, ListRecurringEntriesResponse, ListSchemasRequest, ListSchemasResponse, ListWorkflowsRequest, ListWorkflowsResponse, PostEntryRequest, ReconSession, RecurringEntryTemplate, RejectDecisionRequest, ReopenPeriodRequest, ReverseEntryRequest, RunAutoMatchRequest, RunAutoMatchResponse, RunCloseAgentRequest, RunCloseAgentResponse, RunConsolidationRequest, RunConsolidationResponse, RunQualityCheckRequest, RunQualityCheckResponse, RunWorkflowRequest, RunWorkflowResponse, SetAutonomyConfigRequest, SetBudgetAmountRequest, SimulateInScenarioRequest, SimulateInScenarioResponse, StoreSchemaRequest, TrialBalance, UpdateAccountRequest, UpdateRecurringEntryRequest } from "./accounting_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.AccountingService
 */
export const AccountingService = {
  typeName: "omnios.v1.AccountingService",
  methods: {
    /**
     * -- Journal Entries --
     *
     * @generated from rpc omnios.v1.AccountingService.PostEntry
     */
    postEntry: {
      name: "PostEntry",
      I: PostEntryRequest,
      O: JournalEntry,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetEntry
     */
    getEntry: {
      name: "GetEntry",
      I: GetEntryRequest,
      O: JournalEntry,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ListEntries
     */
    listEntries: {
      name: "ListEntries",
      I: ListEntriesRequest,
      O: ListEntriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ReverseEntry
     */
    reverseEntry: {
      name: "ReverseEntry",
      I: ReverseEntryRequest,
      O: JournalEntry,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.DraftEntry
     */
    draftEntry: {
      name: "DraftEntry",
      I: DraftEntryRequest,
      O: JournalEntry,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ApproveEntry
     */
    approveEntry: {
      name: "ApproveEntry",
      I: ApproveEntryRequest,
      O: JournalEntry,
      kind: MethodKind.Unary,
    },
    /**
     * -- Chart of Accounts --
     *
     * @generated from rpc omnios.v1.AccountingService.CreateAccount
     */
    createAccount: {
      name: "CreateAccount",
      I: CreateAccountRequest,
      O: Account,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetAccount
     */
    getAccount: {
      name: "GetAccount",
      I: GetAccountRequest,
      O: Account,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.UpdateAccount
     */
    updateAccount: {
      name: "UpdateAccount",
      I: UpdateAccountRequest,
      O: Account,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ListAccounts
     */
    listAccounts: {
      name: "ListAccounts",
      I: ListAccountsRequest,
      O: ListAccountsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Balances --
     *
     * @generated from rpc omnios.v1.AccountingService.GetBalance
     */
    getBalance: {
      name: "GetBalance",
      I: GetBalanceRequest,
      O: AccountBalance,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetTrialBalance
     */
    getTrialBalance: {
      name: "GetTrialBalance",
      I: GetTrialBalanceRequest,
      O: TrialBalance,
      kind: MethodKind.Unary,
    },
    /**
     * -- Reports --
     *
     * @generated from rpc omnios.v1.AccountingService.GetIncomeStatement
     */
    getIncomeStatement: {
      name: "GetIncomeStatement",
      I: GetReportRequest,
      O: FinancialStatement,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetBalanceSheet
     */
    getBalanceSheet: {
      name: "GetBalanceSheet",
      I: GetReportRequest,
      O: FinancialStatement,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetCashFlowStatement
     */
    getCashFlowStatement: {
      name: "GetCashFlowStatement",
      I: GetReportRequest,
      O: CashFlowStatement,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetAccountStatement
     */
    getAccountStatement: {
      name: "GetAccountStatement",
      I: GetAccountStatementRequest,
      O: AccountStatementResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Period Close --
     *
     * @generated from rpc omnios.v1.AccountingService.ListPeriods
     */
    listPeriods: {
      name: "ListPeriods",
      I: ListPeriodsRequest,
      O: ListPeriodsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetCloseChecklist
     */
    getCloseChecklist: {
      name: "GetCloseChecklist",
      I: GetCloseChecklistRequest,
      O: CloseChecklist,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.RunCloseAgent
     */
    runCloseAgent: {
      name: "RunCloseAgent",
      I: RunCloseAgentRequest,
      O: RunCloseAgentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ClosePeriod
     */
    closePeriod: {
      name: "ClosePeriod",
      I: ClosePeriodRequest,
      O: FiscalPeriod,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ReopenPeriod
     */
    reopenPeriod: {
      name: "ReopenPeriod",
      I: ReopenPeriodRequest,
      O: FiscalPeriod,
      kind: MethodKind.Unary,
    },
    /**
     * -- Schema --
     *
     * @generated from rpc omnios.v1.AccountingService.StoreSchema
     */
    storeSchema: {
      name: "StoreSchema",
      I: StoreSchemaRequest,
      O: LedgerSchemaProto,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetSchema
     */
    getSchema: {
      name: "GetSchema",
      I: GetSchemaRequest,
      O: LedgerSchemaProto,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ListSchemas
     */
    listSchemas: {
      name: "ListSchemas",
      I: ListSchemasRequest,
      O: ListSchemasResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Reconciliation --
     *
     * @generated from rpc omnios.v1.AccountingService.CreateReconSession
     */
    createReconSession: {
      name: "CreateReconSession",
      I: CreateReconSessionRequest,
      O: ReconSession,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetReconSession
     */
    getReconSession: {
      name: "GetReconSession",
      I: GetReconSessionRequest,
      O: ReconSession,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.RunAutoMatch
     */
    runAutoMatch: {
      name: "RunAutoMatch",
      I: RunAutoMatchRequest,
      O: RunAutoMatchResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.AcceptMatch
     */
    acceptMatch: {
      name: "AcceptMatch",
      I: AcceptMatchRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.FinalizeRecon
     */
    finalizeRecon: {
      name: "FinalizeRecon",
      I: FinalizeReconRequest,
      O: ReconSession,
      kind: MethodKind.Unary,
    },
    /**
     * -- Agents --
     *
     * @generated from rpc omnios.v1.AccountingService.ListDecisions
     */
    listDecisions: {
      name: "ListDecisions",
      I: ListDecisionsRequest,
      O: ListDecisionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ApproveDecision
     */
    approveDecision: {
      name: "ApproveDecision",
      I: ApproveDecisionRequest,
      O: AgentDecision,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.RejectDecision
     */
    rejectDecision: {
      name: "RejectDecision",
      I: RejectDecisionRequest,
      O: AgentDecision,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetAutonomyConfig
     */
    getAutonomyConfig: {
      name: "GetAutonomyConfig",
      I: GetAutonomyConfigRequest,
      O: AutonomyConfig,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.SetAutonomyConfig
     */
    setAutonomyConfig: {
      name: "SetAutonomyConfig",
      I: SetAutonomyConfigRequest,
      O: AutonomyConfig,
      kind: MethodKind.Unary,
    },
    /**
     * -- Budget --
     *
     * @generated from rpc omnios.v1.AccountingService.GetBudgetVariance
     */
    getBudgetVariance: {
      name: "GetBudgetVariance",
      I: GetBudgetVarianceRequest,
      O: BudgetVarianceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.SetBudgetAmount
     */
    setBudgetAmount: {
      name: "SetBudgetAmount",
      I: SetBudgetAmountRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * -- Fixed Assets --
     *
     * @generated from rpc omnios.v1.AccountingService.CreateFixedAsset
     */
    createFixedAsset: {
      name: "CreateFixedAsset",
      I: CreateFixedAssetRequest,
      O: FixedAsset,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ListFixedAssets
     */
    listFixedAssets: {
      name: "ListFixedAssets",
      I: ListFixedAssetsRequest,
      O: ListFixedAssetsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.DisposeFixedAsset
     */
    disposeFixedAsset: {
      name: "DisposeFixedAsset",
      I: DisposeFixedAssetRequest,
      O: FixedAsset,
      kind: MethodKind.Unary,
    },
    /**
     * -- Credit --
     *
     * @generated from rpc omnios.v1.AccountingService.CheckCredit
     */
    checkCredit: {
      name: "CheckCredit",
      I: CheckCreditRequest,
      O: CheckCreditResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Intercompany --
     *
     * @generated from rpc omnios.v1.AccountingService.ListIcTransactions
     */
    listIcTransactions: {
      name: "ListIcTransactions",
      I: ListIcTransactionsRequest,
      O: ListIcTransactionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Consolidation --
     *
     * @generated from rpc omnios.v1.AccountingService.RunConsolidation
     */
    runConsolidation: {
      name: "RunConsolidation",
      I: RunConsolidationRequest,
      O: RunConsolidationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Account Analysis --
     *
     * @generated from rpc omnios.v1.AccountingService.GetAccountAnalysis
     */
    getAccountAnalysis: {
      name: "GetAccountAnalysis",
      I: GetAccountAnalysisRequest,
      O: AccountAnalysisResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.GetCrossTabBalance
     */
    getCrossTabBalance: {
      name: "GetCrossTabBalance",
      I: GetCrossTabBalanceRequest,
      O: CrossTabBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Recurring Entries --
     *
     * @generated from rpc omnios.v1.AccountingService.CreateRecurringEntry
     */
    createRecurringEntry: {
      name: "CreateRecurringEntry",
      I: CreateRecurringEntryRequest,
      O: RecurringEntryTemplate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.ListRecurringEntries
     */
    listRecurringEntries: {
      name: "ListRecurringEntries",
      I: ListRecurringEntriesRequest,
      O: ListRecurringEntriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.UpdateRecurringEntry
     */
    updateRecurringEntry: {
      name: "UpdateRecurringEntry",
      I: UpdateRecurringEntryRequest,
      O: RecurringEntryTemplate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.DeleteRecurringEntry
     */
    deleteRecurringEntry: {
      name: "DeleteRecurringEntry",
      I: DeleteRecurringEntryRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * -- Regulatory Operations --
     *
     * @generated from rpc omnios.v1.AccountingService.ListWorkflows
     */
    listWorkflows: {
      name: "ListWorkflows",
      I: ListWorkflowsRequest,
      O: ListWorkflowsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.RunWorkflow
     */
    runWorkflow: {
      name: "RunWorkflow",
      I: RunWorkflowRequest,
      O: RunWorkflowResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Batch Operations --
     *
     * @generated from rpc omnios.v1.AccountingService.BatchPostEntries
     */
    batchPostEntries: {
      name: "BatchPostEntries",
      I: BatchPostEntriesRequest,
      O: BatchPostEntriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.AccountingService.BatchReverseEntries
     */
    batchReverseEntries: {
      name: "BatchReverseEntries",
      I: BatchReverseEntriesRequest,
      O: BatchReverseEntriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Validation --
     *
     * @generated from rpc omnios.v1.AccountingService.RunQualityCheck
     */
    runQualityCheck: {
      name: "RunQualityCheck",
      I: RunQualityCheckRequest,
      O: RunQualityCheckResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Counterparty Reconciliation --
     *
     * @generated from rpc omnios.v1.AccountingService.GetCounterpartyRecon
     */
    getCounterpartyRecon: {
      name: "GetCounterpartyRecon",
      I: GetCounterpartyReconRequest,
      O: GetCounterpartyReconResponse,
      kind: MethodKind.Unary,
    },
    /**
     * -- Shadow Ledger / Simulation --
     *
     * @generated from rpc omnios.v1.AccountingService.SimulateInScenario
     */
    simulateInScenario: {
      name: "SimulateInScenario",
      I: SimulateInScenarioRequest,
      O: SimulateInScenarioResponse,
      kind: MethodKind.Unary,
    },
  }
};

